import React, { useEffect, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import Home from '../img/sidebar/home.png'
import HomeActive from '../img/sidebar/home_active.png'
import Note from '../img/sidebar/note.png'
import NoteActive from '../img/sidebar/note_active.png'
import Customer from '../img/sidebar/customer.png'
import CustomerActive from '../img/sidebar/customer_active.png'
import Setting from '../img/sidebar/setting.png'
import SettingActive from '../img/sidebar/setting_active.png'
import Insurance from '../img/sidebar/ins.png'
import InsuranceActive from '../img/sidebar/ins_active.png'
import './Sidebar.css'
import useEstimateStore from '../stores/estimate'

const Sidebar = (props:any) => {
    const location = useLocation()
    const {setEstimate} = useEstimateStore()
    const [activePath, setActivePath] = useState(location.pathname)

    useEffect(() => { setActivePath(location.pathname) }, [location])
    const [over, setOver] = useState("")
    
    return (
        <div className="menubar">
            <ul>
                <li className={activePath === '/' || activePath === '/main'? 'on' : ''}
                    onMouseOver={() => setOver("home")} onMouseOut={() => setOver("")}>
                    <Link to="/main">
                        <img src={over==="home" || (activePath === '/' || activePath === '/main')? HomeActive : Home} alt="Main Page"/>
                    <span>HOME</span>
                    </Link>
                </li>
                <li className={activePath === '/note' ? 'on' : ''}
                    onMouseOver={() => setOver("note")} onMouseOut={() => setOver("")}>
                    <Link to="/note" onClick={()=>{setEstimate(null)}}>
                        <img src={over==="note" ||  activePath === '/note'? NoteActive : Note} alt="Note Page"/>
                    <span>수첩</span>
                    </Link>
                </li>
                <li className={activePath === '/customer' ? 'on' : ''}
                    onMouseOver={() => setOver("customer")} onMouseOut={() => setOver("")}>
                    <Link to="/customer">
                        <img src={over==="customer" ||  activePath === '/customer'? CustomerActive : Customer} alt="Customer Page"/>
                    <span>고객</span>
                    </Link>
                </li>
                <li className={activePath === '/setting' ? 'on' : ''}
                    onMouseOver={() => setOver("setting")} onMouseOut={() => setOver("")}>
                    <Link to="/setting">
                        <img src={over==="setting" ||  activePath === '/setting'? SettingActive : Setting} alt="Setting Page"/>
                    <span>설정</span>
                    </Link>
                </li>

                {/* <li className={activePath === '/insurance' ? 'on' : ''}
                    onMouseOver={() => setOver("ins")} onMouseOut={() => setOver("")}>
                    <Link to="/insurance">
                        <img src={over==="ins" ||  activePath === '/insurance'? InsuranceActive : Insurance} alt="Insurance Page"/>
                    <span>보험</span>
                    </Link>
                </li> */}
            </ul>
        </div>
    )
}

export default Sidebar
